import {call, put, takeEvery} from 'redux-saga/effects';
import * as chartActionTypes from './actionTypes';
import * as actionTypes from './../../actionTypes';
import AsyncWidgetService from "../../../../services/async/AsyncWidgetService";

function* loadBatchKPIEvolutionWidgetValues({ id }) {
    try {
        const value = yield call(getBatchKPIEvolutionWidgetValueRequest, id);
        yield put({
            type: actionTypes.LOAD_WIDGET_DATA_SUCCESS,
            id: id,
            data: value
        })
    } catch (e) {
        yield put({
            id: id,
            type: actionTypes.LOAD_WIDGET_DATA_FAILED
        });
    }
}

const batchKPIEvolutionSagas = [
    takeEvery(chartActionTypes.LOAD_BATCH_KPI_EVOLUTION_WIDGET_VALUES,  loadBatchKPIEvolutionWidgetValues)
];

const getBatchKPIEvolutionWidgetValueRequest = (id) => {
    return AsyncWidgetService.getBatchKPIEvolutionWidgetReadings(id);
};

export { batchKPIEvolutionSagas };